import { newIdempotencyKey } from './api'

/** One id per intent, held until it succeeds: a press repeated after a lost answer
 *  sends the same id, and a new press after a success draws a new one. */
export function createIntents(draw: () => string = newIdempotencyKey) {
  const held = new Map<string, string>()
  return {
    keyFor(intent: string): string {
      let key = held.get(intent)
      if (!key) {
        key = draw()
        held.set(intent, key)
      }
      return key
    },
    done(intent: string): void {
      held.delete(intent)
    },
    /** Forget every intent whose key is among those now seen recorded: it succeeded
     *  even if its answer was lost, and a later press is a new intent. */
    settle(recorded: Iterable<string>): void {
      const seen = new Set(recorded)
      for (const [intent, key] of held) if (seen.has(key)) held.delete(intent)
    },
  }
}

export type Intents = ReturnType<typeof createIntents>
